export default {"src":"/_next/static/media/Dog-friend-animation.751e4571.gif","height":1084,"width":1930};